/** Prompt strings for the empty-thread welcome (also mirrored on the adapter as `suggestions`). */
export const OMICS_WELCOME_PROMPTS: readonly string[] = [
  'What is a gene enrichment analysis?',
  'How do I interpret a volcano plot?',
  'Explain PCA in the context of RNA-seq',
  'Search the internet for information about ...',
  'Use the attached files to perform an differential expression analysis',
]
